var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 137,
    viewBox: "0 0 123 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3336 2.847C58.3679 -0.140997 64.6321 -0.140998 69.6664 2.847L91.815 15.9929L114.274 28.6012C119.379 31.467 122.511 36.892 122.44 42.7458L122.13 68.5L122.44 94.2542C122.511 100.108 119.379 105.533 114.274 108.399L91.815 121.007L69.6664 134.153C64.6321 137.141 58.3679 137.141 53.3336 134.153L31.185 121.007L8.72603 108.399C3.62121 105.533 0.489099 100.108 0.559642 94.2542L0.870003 68.5L0.559642 42.7458C0.489099 36.892 3.62121 31.467 8.72603 28.6012L31.185 15.9929L53.3336 2.847Z",
    fill: "url(#paint0_linear_1629_2248)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1629_2248",
    x1: 92,
    y1: 9,
    x2: 24,
    y2: 131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FD965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93617,
    stopColor: "#19AA58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.1a3c4e57363f44935570e39c7b6dc683.svg";
export { ForwardRef as ReactComponent };